// Module "human" : personnage MakeHuman CC0 morphable, squelette, proxies et morphs temps réel.
// Point d'entrée public — voir types.ts pour le contrat et docs/asset-format.md pour les données.
import type { CreateHumanOptions, Human } from './types';
import { HumanImpl, type CreateHumanExtraOptions } from './human';

export type * from './types';
export type { CreateHumanExtraOptions, CatalogFile } from './human';
export type { ModifiersFile, ModifierDef } from './format';
export { HumanImpl, loadCatalog, loadModifiers } from './human';
export { defaultParams, cloneParams, computeTargetWeights, macroVariables, normalizeEthnics } from './modifiers';
export { defaultMaterial, materialRequest } from './materials';
export { clearAssetCache } from './fetcher';

/**
 * Crée un personnage. Les assets sont lus sous opts.baseUrl (ex. "/assets/gen/").
 * - params absent : jeune femme adulte (defaultParams()).
 * - skin / eyeMaterial absents ou '' : valeurs par défaut de catalog.json.
 * - proxies absent : yeux, sourcils, cils, dents, langue et cheveux par défaut ;
 *   proxies fourni : yeux/sourcils/cils/dents/langue par défaut sauf si le slot est donné ('' = aucun),
 *   cheveux et vêtements uniquement s'ils sont listés.
 */
export async function createHuman(opts: CreateHumanOptions & CreateHumanExtraOptions): Promise<Human> {
  const h = new HumanImpl(opts);
  await h.init();
  return h;
}
